/**
 * This file is autogenerated from: 
 *
 *    php artisan maint:constants:regenerate
 *
 * Changes to this file will be lost.
 */

const _ = window._LP;

window.App_Models_Activity = class App_Models_Activity extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Activity", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Activity", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Activity", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Activity", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Activity";
    }

    static TYPE_GENERIC = 0;
    static TYPE_CREATED = 1;
    static TYPE_UPDATED = 2;
    static TYPE_DELETED = 3;
    static TYPE_APPROVED = 4;
    static TYPE_DENIED = 5;
    static TYPE_LOGGED_IN = 6;
    static TYPE_STATUS_CHANGED = 7;
    static TYPE_SENT_SMS = 8;
    static TYPE_CUSTOM = 9;
    static TYPE_NOTICE = 10;
    static TYPE_MIGRATED = 11;
    static TYPE_EVENT_PUBLIC = 12;
    static TYPE_EVENT_REGISTRANT = 13;
    static TYPE_EVENT_BACKEND = 14;
    static TYPE_EVENT_ROOT = 15;
    static TYPE_ERROR = 16;
    static TYPE_LOCK = 17;

    static type_id_enum_val() { return {
    "0": {
        "label": "Generic",
        "constant": "TYPE_GENERIC"
    },
    "1": {
        "label": "Created",
        "constant": "TYPE_CREATED"
    },
    "2": {
        "label": "Updated",
        "constant": "TYPE_UPDATED"
    },
    "3": {
        "label": "Deleted",
        "constant": "TYPE_DELETED"
    },
    "4": {
        "label": "Approved",
        "constant": "TYPE_APPROVED"
    },
    "5": {
        "label": "Denied",
        "constant": "TYPE_DENIED"
    },
    "6": {
        "label": "Logged In",
        "constant": "TYPE_LOGGED_IN"
    },
    "7": {
        "label": "Status Changed",
        "constant": "TYPE_STATUS_CHANGED"
    },
    "8": {
        "label": "Sent SMS",
        "constant": "TYPE_SENT_SMS"
    },
    "9": {
        "label": "Custom",
        "constant": "TYPE_CUSTOM"
    },
    "10": {
        "label": "Notice",
        "constant": "TYPE_NOTICE"
    },
    "11": {
        "label": "Migrated",
        "constant": "TYPE_MIGRATED"
    },
    "12": {
        "label": "Public Event Log",
        "constant": "TYPE_EVENT_PUBLIC"
    },
    "13": {
        "label": "Registrant Event Log",
        "constant": "TYPE_EVENT_REGISTRANT"
    },
    "14": {
        "label": "Private Event Log",
        "constant": "TYPE_EVENT_BACKEND"
    },
    "15": {
        "label": "Root Event Log",
        "constant": "TYPE_EVENT_ROOT"
    },
    "16": {
        "label": "Error Log",
        "constant": "TYPE_ERROR"
    },
    "17": {
        "label": "LOCK()",
        "constant": "TYPE_LOCK"
    }
}; }

    static type_id_enum_select() { 
                    return Object.entries(App_Models_Activity.type_id_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_Agency = class App_Models_Agency extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Agency", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Agency", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Agency", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Agency", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Agency";
    }

    static STATUS_ACTIVE = 1;
    static STATUS_INACTIVE = 2;
    static STATUS_PENDING_APPROVAL = 3;
    static STATUS_SUSPENDED = 4;

    static status_enum_val() { return {
    "1": {
        "label": "Active",
        "constant": "STATUS_ACTIVE",
        "badge": "bg-success",
        "order": 1
    },
    "2": {
        "label": "Inactive",
        "constant": "STATUS_INACTIVE",
        "badge": "bg-secondary",
        "order": 2
    },
    "3": {
        "label": "Pending Approval",
        "constant": "STATUS_PENDING_APPROVAL",
        "badge": "bg-warning",
        "order": 3
    },
    "4": {
        "label": "Suspended",
        "constant": "STATUS_SUSPENDED",
        "badge": "bg-danger",
        "order": 4
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_Agency.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_ApiClient = class App_Models_ApiClient extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ApiClient", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ApiClient", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ApiClient", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ApiClient", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ApiClient";
    }

}

window.App_Models_ApprovalComment = class App_Models_ApprovalComment extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ApprovalComment", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalComment", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalComment", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ApprovalComment", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ApprovalComment";
    }

}

window.App_Models_ApprovalDocument = class App_Models_ApprovalDocument extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ApprovalDocument", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalDocument", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalDocument", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ApprovalDocument", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ApprovalDocument";
    }

    static STATUS_INFO = 1;
    static STATUS_PENDING = 2;
    static STATUS_APPROVED = 3;
    static STATUS_REJECTED = 4;
    static STATUS_NEEDS_REVISION = 5;

    static status_enum_val() { return {
    "1": {
        "label": "Information",
        "constant": "STATUS_INFO",
        "badge": "bg-info",
        "icon": "fas fa-info-circle text-info",
        "order": 1
    },
    "2": {
        "label": "Pending Review",
        "constant": "STATUS_PENDING",
        "badge": "bg-warning",
        "icon": "fas fa-clock text-warning",
        "order": 2
    },
    "3": {
        "label": "Approved",
        "constant": "STATUS_APPROVED",
        "badge": "bg-success",
        "icon": "fas fa-check-circle text-success",
        "order": 3
    },
    "4": {
        "label": "Rejected",
        "constant": "STATUS_REJECTED",
        "badge": "bg-danger",
        "icon": "fas fa-times-circle text-danger",
        "order": 4
    },
    "5": {
        "label": "Needs Revision",
        "constant": "STATUS_NEEDS_REVISION",
        "badge": "bg-info",
        "icon": "fas fa-edit text-info",
        "order": 5
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_ApprovalDocument.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_ApprovalRequest = class App_Models_ApprovalRequest extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ApprovalRequest", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalRequest", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalRequest", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ApprovalRequest", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ApprovalRequest";
    }

    static STATUS_DRAFT = 1;
    static STATUS_SUBMITTED = 2;
    static STATUS_UNDER_REVIEW = 3;
    static STATUS_NEEDS_CHANGES = 4;
    static STATUS_APPROVED = 5;
    static STATUS_REJECTED = 6;
    static STATUS_COMPLETED = 7;

    static status_enum_val() { return {
    "1": {
        "label": "Draft",
        "constant": "STATUS_DRAFT",
        "badge": "bg-secondary",
        "order": 1
    },
    "2": {
        "label": "Submitted",
        "constant": "STATUS_SUBMITTED",
        "badge": "bg-info",
        "order": 2
    },
    "3": {
        "label": "Under Review",
        "constant": "STATUS_UNDER_REVIEW",
        "badge": "bg-warning",
        "order": 3
    },
    "4": {
        "label": "Needs Changes",
        "constant": "STATUS_NEEDS_CHANGES",
        "badge": "bg-danger",
        "order": 4
    },
    "5": {
        "label": "Approved",
        "constant": "STATUS_APPROVED",
        "badge": "bg-success",
        "order": 5
    },
    "6": {
        "label": "Rejected",
        "constant": "STATUS_REJECTED",
        "badge": "bg-danger",
        "order": 6
    },
    "7": {
        "label": "Completed",
        "constant": "STATUS_COMPLETED",
        "badge": "bg-primary",
        "order": 7
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_ApprovalRequest.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static REQUEST_TYPE_AGENCY_CREATION = 1;
    static REQUEST_TYPE_AUCTION_CREATION = 2;

    static request_type_enum_val() { return {
    "1": {
        "label": "Agency Creation",
        "constant": "REQUEST_TYPE_AGENCY_CREATION"
    },
    "2": {
        "label": "Auction Creation",
        "constant": "REQUEST_TYPE_AUCTION_CREATION"
    }
}; }

    static request_type_enum_select() { 
                    return Object.entries(App_Models_ApprovalRequest.request_type_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_ApprovalRequirement = class App_Models_ApprovalRequirement extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ApprovalRequirement", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalRequirement", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ApprovalRequirement", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ApprovalRequirement", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ApprovalRequirement";
    }

    static STATUS_DRAFT = 1;
    static STATUS_ACTIVE = 2;
    static STATUS_UNDER_REVIEW = 3;
    static STATUS_APPROVED = 4;
    static STATUS_REJECTED = 5;

    static status_enum_val() { return {
    "1": {
        "label": "Draft",
        "constant": "STATUS_DRAFT",
        "badge": "bg-secondary",
        "icon": "fas fa-file-alt text-secondary",
        "order": 1
    },
    "2": {
        "label": "Active",
        "constant": "STATUS_ACTIVE",
        "badge": "bg-primary",
        "icon": "fas fa-play-circle text-primary",
        "order": 2
    },
    "3": {
        "label": "Under Review",
        "constant": "STATUS_UNDER_REVIEW",
        "badge": "bg-warning",
        "icon": "fas fa-search text-warning",
        "order": 3
    },
    "4": {
        "label": "Approved",
        "constant": "STATUS_APPROVED",
        "badge": "bg-success",
        "icon": "fas fa-check-circle text-success",
        "order": 4
    },
    "5": {
        "label": "Rejected",
        "constant": "STATUS_REJECTED",
        "badge": "bg-danger",
        "icon": "fas fa-times-circle text-danger",
        "order": 5
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_ApprovalRequirement.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_Auction = class App_Models_Auction extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Auction", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Auction", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Auction", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Auction", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Auction";
    }

    static STATUS_DRAFT = 3;
    static STATUS_PUBLISHED = 6;
    static STATUS_ACTIVE = 4;
    static STATUS_CONTRACT = 1;
    static STATUS_COMPLETE = 2;
    static STATUS_CANCELED = 5;

    static auction_status_enum_val() { return {
    "3": {
        "order": 0,
        "label": "Draft",
        "label_frontend": "Draft",
        "constant": "STATUS_DRAFT",
        "badge": "bg-secondary status-badge",
        "badge_frontend": "badge-secondary",
        "visible_frontend": false,
        "can_bid": false
    },
    "6": {
        "order": 1,
        "label": "New Listing",
        "label_frontend": "New Listing",
        "constant": "STATUS_PUBLISHED",
        "badge": "bg-primary status-badge",
        "badge_frontend": "badge-success",
        "visible_frontend": true,
        "can_bid": false
    },
    "4": {
        "order": 2,
        "label": "Accepting Bids",
        "label_frontend": "Accepting Bids",
        "constant": "STATUS_ACTIVE",
        "badge": "bg-success status-badge",
        "badge_frontend": "badge-success",
        "visible_frontend": true,
        "can_bid": true
    },
    "1": {
        "order": 3,
        "label_frontend": "Under Contract",
        "label": "Under Contract",
        "constant": "STATUS_CONTRACT",
        "badge": "bg-secondary status-badge",
        "badge_frontend": "bg-secondary",
        "visible": false,
        "can_bid": false
    },
    "2": {
        "order": 4,
        "label": "Sold",
        "label_frontend": "Sold",
        "constant": "STATUS_COMPLETE",
        "badge": "bg-primary status-badge",
        "badge_frontend": "badge-primary",
        "visible_frontend": true,
        "can_bid": false
    },
    "5": {
        "order": 5,
        "label": "Canceled",
        "label_frontend": "Canceled",
        "constant": "STATUS_CANCELED",
        "badge": "bg-warning status-badge",
        "badge_frontend": "badge-secondary",
        "visible_frontend": false,
        "can_bid": false
    }
}; }

    static auction_status_enum_select() { 
                    return Object.entries(App_Models_Auction.auction_status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static AUCTION_FORMAT_STANDARD = 0;
    static AUCTION_FORMAT_CHOICE = 3;
    static AUCTION_FORMAT_ENTERPRISE = 4;
    static AUCTION_FORMAT_SEALED_BID = 5;

    static auction_format_enum_val() { return {
    "0": {
        "label": "Standard",
        "constant": "AUCTION_FORMAT_STANDARD"
    },
    "3": {
        "label": "Choice",
        "constant": "AUCTION_FORMAT_CHOICE"
    },
    "4": {
        "label": "Whole Farm",
        "constant": "AUCTION_FORMAT_ENTERPRISE"
    },
    "5": {
        "label": "Sealed Bid",
        "constant": "AUCTION_FORMAT_SEALED_BID"
    }
}; }

    static auction_format_enum_select() { 
                    return Object.entries(App_Models_Auction.auction_format_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static AUTO_APPROVE_ASK = 1;
    static AUTO_APPROVE_ALL = 2;
    static AUTO_APPROVE_NONE = 3;

    static auto_approve_enum_val() { return {
    "1": {
        "label": "Auto Approve Ask Bid",
        "constant": "AUTO_APPROVE_ASK"
    },
    "2": {
        "label": "Auto Approve All",
        "constant": "AUTO_APPROVE_ALL"
    },
    "3": {
        "label": "Auto Approve None",
        "constant": "AUTO_APPROVE_NONE"
    }
}; }

    static auto_approve_enum_select() { 
                    return Object.entries(App_Models_Auction.auto_approve_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_AuctionCast = class App_Models_AuctionCast extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctionCast", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctionCast", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctionCast", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctionCast", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctionCast";
    }

}

window.App_Models_AuctionCastStreamHistory = class App_Models_AuctionCastStreamHistory extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctionCastStreamHistory", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctionCastStreamHistory", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctionCastStreamHistory", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctionCastStreamHistory", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctionCastStreamHistory";
    }

}

window.App_Models_AuctionCastStreamViewerStats = class App_Models_AuctionCastStreamViewerStats extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctionCastStreamViewerStats", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctionCastStreamViewerStats", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctionCastStreamViewerStats", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctionCastStreamViewerStats", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctionCastStreamViewerStats";
    }

}

window.App_Models_AuctionItem = class App_Models_AuctionItem extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctionItem", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctionItem", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctionItem", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctionItem", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctionItem";
    }

    static STATUS_AVAILABLE = 0;
    static STATUS_SOLD = 1;
    static STATUS_NO_SALE = 2;

    static status_enum_val() { return {
    "0": {
        "label": "Available",
        "constant": "STATUS_AVAILABLE",
        "is_complete": false,
        "clerk_short_badge_label": "Available",
        "can_bid": true,
        "badge": "bg-success status-badge",
        "badge_frontend": "badge-success",
        "order": 1
    },
    "1": {
        "label": "Sold",
        "constant": "STATUS_SOLD",
        "is_complete": true,
        "clerk_short_badge_label": "Sold",
        "can_bid": false,
        "badge": "bg-primary status-badge",
        "badge_frontend": "badge-primary",
        "order": 2
    },
    "2": {
        "label": "No Sale",
        "constant": "STATUS_NO_SALE",
        "is_complete": true,
        "clerk_short_badge_label": "No Sale",
        "can_bid": false,
        "badge": "bg-danger status-badge",
        "badge_frontend": "badge-danger",
        "order": 3
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_AuctionItem.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static PRICING_STYLE_PER_ACRE = 1;
    static PRICING_STYLE_FLAT = 2;

    static pricing_style_enum_val() { return {
    "1": {
        "label": "Per Acres",
        "constant": "PRICING_STYLE_PER_ACRE"
    },
    "2": {
        "label": "Flat Price",
        "constant": "PRICING_STYLE_FLAT"
    }
}; }

    static pricing_style_enum_select() { 
                    return Object.entries(App_Models_AuctionItem.pricing_style_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_AuctionRegistration = class App_Models_AuctionRegistration extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctionRegistration", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctionRegistration", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctionRegistration", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctionRegistration", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctionRegistration";
    }

}

window.App_Models_AuctionRound = class App_Models_AuctionRound extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctionRound", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctionRound", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctionRound", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctionRound", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctionRound";
    }

    static STATUS_DRAFT = 8;
    static STATUS_PENDING = 9;
    static STATUS_ACTIVE = 1;
    static STATUS_FINALIZING = 2;
    static STATUS_SOLD = 3;
    static STATUS_PAUSED = 4;
    static STATUS_CANCELED = 5;
    static STATUS_ONCE = 6;
    static STATUS_TWICE = 7;
    static STATUS_NO_SALE = 10;
    static STATUS_SOLD_AS_WHOLE_FARM = 11;
    static STATUS_SOLD_AS_TRACTS = 12;

    static status_enum_val() { return {
    "8": {
        "label": "Draft",
        "constant": "STATUS_DRAFT",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Draft",
        "can_bid": false,
        "badge": "bg-warning status-badge",
        "badge_frontend": "badge-warning",
        "next_action": "start",
        "order": 1,
        "selectable": false
    },
    "9": {
        "label": "Upcoming",
        "constant": "STATUS_PENDING",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Upcoming",
        "can_bid": false,
        "badge": "bg-secondary status-badge",
        "badge_frontend": "badge-secondary",
        "next_action": "start",
        "order": 2
    },
    "1": {
        "label": "Accepting Bids",
        "constant": "STATUS_ACTIVE",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Accepting Bids",
        "can_bid": true,
        "badge": "bg-success status-badge",
        "badge_frontend": "badge-success",
        "next_action": "pause",
        "order": 3
    },
    "2": {
        "label": "Pending Approval",
        "constant": "STATUS_FINALIZING",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Pending Approval",
        "can_bid": false,
        "badge": "bg-info2 status-badge",
        "badge_frontend": "badge-warning",
        "next_action": "start",
        "order": 4
    },
    "3": {
        "label": "Sold",
        "constant": "STATUS_SOLD",
        "is_complete": true,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Sold",
        "can_bid": false,
        "badge": "bg-primary status-badge",
        "badge_frontend": "badge-success",
        "next_action": "dangerous_reopen",
        "order": 5
    },
    "4": {
        "label": "Bidding Paused",
        "constant": "STATUS_PAUSED",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Bidding Paused",
        "can_bid": false,
        "badge": "bg-warning status-badge",
        "badge_frontend": "badge-dark",
        "next_action": "start",
        "order": 6
    },
    "5": {
        "label": "Canceled",
        "constant": "STATUS_CANCELED",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Canceled",
        "can_bid": false,
        "badge": "bg-danger status-badge",
        "badge_frontend": "badge-secondary",
        "next_action": "reopen",
        "order": 7
    },
    "6": {
        "label": "Going Once",
        "constant": "STATUS_ONCE",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Going Once",
        "can_bid": true,
        "badge": "bg-info2 status-badge",
        "badge_frontend": "badge-info",
        "next_action": "pause",
        "order": 8
    },
    "7": {
        "label": "Going Twice",
        "constant": "STATUS_TWICE",
        "is_complete": false,
        "is_unsold": false,
        "enterprise_only": false,
        "clerk_short_badge_label": "Going Twice",
        "can_bid": true,
        "badge": "bg-warning status-badge",
        "badge_frontend": "badge-warning",
        "next_action": "pause",
        "order": 9
    },
    "10": {
        "label": "No Sale",
        "constant": "STATUS_NO_SALE",
        "is_complete": true,
        "is_unsold": true,
        "enterprise_only": false,
        "clerk_short_badge_label": "No Sale",
        "can_bid": false,
        "badge": "bg-secondary status-badge",
        "badge_frontend": "badge-secondary",
        "next_action": "dangerous_reopen",
        "order": 5
    },
    "11": {
        "label": "Sold as Whole Farm",
        "constant": "STATUS_SOLD_AS_WHOLE_FARM",
        "is_complete": true,
        "is_unsold": true,
        "enterprise_only": true,
        "clerk_short_badge_label": "WF No Sale",
        "can_bid": false,
        "badge": "bg-secondary status-badge",
        "badge_frontend": "badge-secondary",
        "next_action": "dangerous_reopen",
        "order": 5
    },
    "12": {
        "label": "Sold as Tracts",
        "constant": "STATUS_SOLD_AS_TRACTS",
        "is_complete": true,
        "is_unsold": true,
        "enterprise_only": true,
        "clerk_short_badge_label": "WF No Sale",
        "can_bid": false,
        "badge": "bg-secondary status-badge",
        "badge_frontend": "badge-secondary",
        "next_action": "dangerous_reopen",
        "order": 5
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_AuctionRound.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_AuctionType = class App_Models_AuctionType extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctionType", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctionType", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctionType", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctionType", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctionType";
    }

}

window.App_Models_AuctioncastInvocation = class App_Models_AuctioncastInvocation extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\AuctioncastInvocation", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\AuctioncastInvocation", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\AuctioncastInvocation", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\AuctioncastInvocation", callback);
    }

    static backend_class_name() {
        return "App\\Models\\AuctioncastInvocation";
    }

}

window.App_Models_Bid = class App_Models_Bid extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Bid", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Bid", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Bid", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Bid", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Bid";
    }

    static STATUS_PENDING = 0;
    static STATUS_ACCEPTED = 1;
    static STATUS_REJECTED = 2;
    static STATUS_PENDING_APPROVAL = 4;
    static STATUS_DELETED = 5;
    static STATUS_OUTBID = 6;
    static STATUS_OUTBID_TIE = 9;
    static STATUS_MAX_BID_ACTIVE = 10;
    static STATUS_MAX_BID_OUTBID = 11;
    static STATUS_MAX_BID_CANCELED = 12;
    static STATUS_MAX_BID_PENDING = 13;
    static STATUS_MAX_BID_PENDING_APPROVAL = 14;
    static STATUS_SEALED_BID = 15;

    static status_enum_val() { return {
    "0": {
        "order": 0,
        "label": "Pending",
        "label_frontend": null,
        "constant": "STATUS_PENDING",
        "badge": "bg-secondary",
        "badge_frontend": "badge-secondary",
        "selectable": true,
        "show_frontend_all": false,
        "show_frontend_registrant": false,
        "show_frontend_notes": "",
        "clerk_strikeout": false,
        "sealed_bid_selectable": false
    },
    "1": {
        "order": 1,
        "label": "Accepted, High Bid",
        "label_frontend": "High Bid",
        "constant": "STATUS_ACCEPTED",
        "badge": "bg-success",
        "badge_frontend": "badge-success",
        "selectable": true,
        "show_frontend_all": true,
        "show_frontend_registrant": true,
        "show_frontend_notes": "High Bid",
        "clerk_strikeout": false,
        "sealed_bid_selectable": true
    },
    "2": {
        "order": 3,
        "label": "Rejected",
        "label_frontend": "Rejected",
        "constant": "STATUS_REJECTED",
        "badge": "bg-danger",
        "badge_frontend": "badge-danger",
        "selectable": true,
        "show_frontend_all": false,
        "show_frontend_registrant": true,
        "show_frontend_notes": "",
        "clerk_strikeout": true,
        "sealed_bid_selectable": false
    },
    "4": {
        "obsolete": true,
        "order": 5,
        "label": "Pending Approval",
        "label_frontend": null,
        "constant": "STATUS_PENDING_APPROVAL",
        "badge": "bg-warning",
        "badge_frontend": "badge-warning",
        "selectable": false,
        "show_frontend_all": false,
        "show_frontend_registrant": false,
        "show_frontend_notes": "",
        "clerk_strikeout": false,
        "sealed_bid_selectable": false
    },
    "5": {
        "order": 6,
        "label": "Deleted",
        "label_frontend": null,
        "constant": "STATUS_DELETED",
        "badge": "bg-dark",
        "badge_frontend": "badge-dark",
        "selectable": true,
        "show_frontend_all": false,
        "show_frontend_registrant": false,
        "show_frontend_notes": "",
        "clerk_strikeout": true,
        "sealed_bid_selectable": true
    },
    "6": {
        "order": 7,
        "label": "Outbid",
        "label_frontend": "Outbid",
        "constant": "STATUS_OUTBID",
        "badge": "bg-danger",
        "badge_frontend": "badge-danger",
        "selectable": true,
        "show_frontend_all": true,
        "show_frontend_registrant": true,
        "show_frontend_notes": "",
        "clerk_strikeout": false,
        "sealed_bid_selectable": false
    },
    "9": {
        "order": 9,
        "label": "Outbid - Same Bid",
        "label_frontend": "Outbid",
        "constant": "STATUS_OUTBID_TIE",
        "badge": "bg-danger",
        "badge_frontend": "badge-danger",
        "selectable": false,
        "show_frontend_all": true,
        "show_frontend_registrant": true,
        "show_frontend_notes": "Same Bid",
        "clerk_strikeout": true,
        "sealed_bid_selectable": false
    },
    "10": {
        "order": 12,
        "label": "Max Bid - Active",
        "label_frontend": "Max Bid - Active",
        "constant": "STATUS_MAX_BID_ACTIVE",
        "badge": "bg-primary",
        "badge_frontend": "badge-primary",
        "selectable": true,
        "show_frontend_all": false,
        "show_frontend_registrant": true,
        "show_frontend_notes": "Active Max Bid",
        "clerk_strikeout": false,
        "sealed_bid_selectable": false
    },
    "11": {
        "order": 13,
        "label": "Max Bid - Outbid",
        "label_frontend": "Max Bid - Outbid",
        "constant": "STATUS_MAX_BID_OUTBID",
        "badge": "bg-danger",
        "badge_frontend": "badge-danger",
        "selectable": false,
        "show_frontend_all": false,
        "show_frontend_registrant": true,
        "show_frontend_notes": "Outbid Max Bid",
        "clerk_strikeout": false,
        "sealed_bid_selectable": false
    },
    "12": {
        "order": 14,
        "label": "Max Bid - Canceled",
        "label_frontend": "Max Bid - Canceled",
        "constant": "STATUS_MAX_BID_CANCELED",
        "badge": "bg-danger",
        "badge_frontend": "badge-danger",
        "selectable": false,
        "show_frontend_all": false,
        "show_frontend_registrant": true,
        "show_frontend_notes": "Canceled Max Bid",
        "clerk_strikeout": true,
        "sealed_bid_selectable": false
    },
    "13": {
        "order": 10,
        "label": "Max Bid - Pending",
        "label_frontend": null,
        "constant": "STATUS_MAX_BID_PENDING",
        "badge": "bg-secondary",
        "badge_frontend": "badge-secondary",
        "selectable": false,
        "show_frontend_all": false,
        "show_frontend_notes": "",
        "clerk_strikeout": false,
        "sealed_bid_selectable": false
    },
    "14": {
        "order": 11,
        "label": "Max Bid - Pending Approval",
        "label_frontend": null,
        "constant": "STATUS_MAX_BID_PENDING_APPROVAL",
        "badge": "bg-warning",
        "badge_frontend": "badge-warning",
        "selectable": false,
        "show_frontend_all": false,
        "show_frontend_notes": "",
        "clerk_strikeout": false,
        "sealed_bid_selectable": false
    },
    "15": {
        "order": 3,
        "label": "Sealed Bid",
        "label_frontend": "Sealed Bid",
        "constant": "STATUS_SEALED_BID",
        "badge": "bg-success",
        "badge_frontend": "badge-success",
        "selectable": false,
        "show_frontend_all": false,
        "show_frontend_registrant": true,
        "clerk_strikeout": false,
        "sealed_bid_selectable": true
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_Bid.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static TYPE_LIVE = 0;
    static TYPE_MANUAL = 1;

    static bid_type_enum_val() { return {
    "0": {
        "label": "Web",
        "constant": "TYPE_LIVE",
        "badge": "bg-secondary"
    },
    "1": {
        "label": "Clerk",
        "constant": "TYPE_MANUAL",
        "badge": "bg-primary"
    }
}; }

    static bid_type_enum_select() { 
                    return Object.entries(App_Models_Bid.bid_type_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static REVIEW_STATUS_NULL = 0;
    static REVIEW_STATUS_PENDING = 1;
    static REVIEW_STATUS_NOT_IN_CONSIDERATION = 2;
    static REVIEW_STATUS_APPROVED = 3;

    static review_status_enum_val() { return {
    "0": {
        "label": "",
        "constant": "REVIEW_STATUS_NULL",
        "badge": "bg-secondary"
    },
    "1": {
        "label": "Needs Review",
        "constant": "REVIEW_STATUS_PENDING",
        "badge": "bg-secondary"
    },
    "2": {
        "label": "Not In Consideration",
        "constant": "REVIEW_STATUS_NOT_IN_CONSIDERATION",
        "badge": "bg-secondary"
    },
    "3": {
        "label": "Approved",
        "constant": "REVIEW_STATUS_APPROVED",
        "badge": "bg-secondary"
    }
}; }

    static review_status_enum_select() { 
                    return Object.entries(App_Models_Bid.review_status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_Campaign = class App_Models_Campaign extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Campaign", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Campaign", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Campaign", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Campaign", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Campaign";
    }

    static STATUS_PENDING = 5;
    static STATUS_ACTIVE = 1;
    static STATUS_PAUSED = 2;
    static STATUS_COMPLETED = 3;
    static STATUS_CANCELLED = 4;
    static STATUS_EXPIRED = 6;

    static status_enum_val() { return {
    "5": {
        "label": "Pending",
        "constant": "STATUS_PENDING",
        "selectable": false,
        "order": 0,
        "badge": "bg-info"
    },
    "1": {
        "label": "Active",
        "constant": "STATUS_ACTIVE",
        "selectable": true,
        "order": 1,
        "badge": "bg-success"
    },
    "2": {
        "label": "Paused",
        "constant": "STATUS_PAUSED",
        "selectable": true,
        "order": 2,
        "badge": "bg-warning"
    },
    "3": {
        "label": "Completed",
        "constant": "STATUS_COMPLETED",
        "selectable": false,
        "order": 3,
        "badge": "bg-secondary"
    },
    "4": {
        "label": "Cancelled",
        "constant": "STATUS_CANCELLED",
        "selectable": false,
        "order": 4,
        "badge": "bg-danger"
    },
    "6": {
        "label": "Expired",
        "constant": "STATUS_EXPIRED",
        "selectable": false,
        "order": 5,
        "badge": "bg-dark"
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_Campaign.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_CampaignContributor = class App_Models_CampaignContributor extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\CampaignContributor", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\CampaignContributor", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\CampaignContributor", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\CampaignContributor", callback);
    }

    static backend_class_name() {
        return "App\\Models\\CampaignContributor";
    }

}

window.App_Models_ChatConversation = class App_Models_ChatConversation extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ChatConversation", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ChatConversation", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ChatConversation", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ChatConversation", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ChatConversation";
    }

}

window.App_Models_ChatConversationAdmin = class App_Models_ChatConversationAdmin extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ChatConversationAdmin", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ChatConversationAdmin", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ChatConversationAdmin", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ChatConversationAdmin", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ChatConversationAdmin";
    }

}

window.App_Models_ChatMessage = class App_Models_ChatMessage extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ChatMessage", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ChatMessage", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ChatMessage", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ChatMessage", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ChatMessage";
    }

}

window.App_Models_Coordinator = class App_Models_Coordinator extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Coordinator", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Coordinator", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Coordinator", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Coordinator", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Coordinator";
    }

}

window.App_Models_DayComment = class App_Models_DayComment extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\DayComment", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\DayComment", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\DayComment", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\DayComment", callback);
    }

    static backend_class_name() {
        return "App\\Models\\DayComment";
    }

}

window.App_Models_DbCache = class App_Models_DbCache extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\DbCache", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\DbCache", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\DbCache", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\DbCache", callback);
    }

    static backend_class_name() {
        return "App\\Models\\DbCache";
    }

}

window.App_Models_EmailQueue = class App_Models_EmailQueue extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\EmailQueue", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\EmailQueue", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\EmailQueue", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\EmailQueue", callback);
    }

    static backend_class_name() {
        return "App\\Models\\EmailQueue";
    }

}

window.App_Models_Event = class App_Models_Event extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Event", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Event", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Event", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Event", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Event";
    }

    static TYPE_AUCTION = 0;
    static TYPE_MEETING = 1;
    static TYPE_LIVE_AND_VIRTUAL = 2;
    static TYPE_ONLINE_TIMED = 3;
    static TYPE_VIRTUAL_ONLINE = 4;
    static TYPE_LIVE = 5;
    static TYPE_ONLINE_ONLY = 6;
    static TYPE_LIVE_AND_ONLINE = 7;

    static type_enum_val() { return {
    "0": {
        "label": "Auction",
        "constant": "TYPE_AUCTION"
    },
    "1": {
        "label": "Meeting",
        "constant": "TYPE_MEETING"
    },
    "2": {
        "label": "Live & Virtual Online Auction",
        "constant": "TYPE_LIVE_AND_VIRTUAL"
    },
    "3": {
        "label": "Online Timed Auction",
        "constant": "TYPE_ONLINE_TIMED"
    },
    "4": {
        "label": "Virtual Online Auction",
        "constant": "TYPE_VIRTUAL_ONLINE"
    },
    "5": {
        "label": "Live Auction",
        "constant": "TYPE_LIVE"
    },
    "6": {
        "label": "Online Only Auction",
        "constant": "TYPE_ONLINE_ONLY"
    },
    "7": {
        "label": "Live & Online Auction",
        "constant": "TYPE_LIVE_AND_ONLINE"
    }
}; }

    static type_enum_select() { 
                    return Object.entries(App_Models_Event.type_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static STATUS_DRAFT = 0;
    static STATUS_PUBLISHED = 1;

    static status_enum_val() { return {
    "0": {
        "label": "Draft",
        "constant": "STATUS_DRAFT"
    },
    "1": {
        "label": "Published",
        "constant": "STATUS_PUBLISHED"
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_Event.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_Form = class App_Models_Form extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Form", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Form", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Form", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Form", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Form";
    }

}

window.App_Models_FormField = class App_Models_FormField extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\FormField", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\FormField", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\FormField", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\FormField", callback);
    }

    static backend_class_name() {
        return "App\\Models\\FormField";
    }

}

window.App_Models_FormNotification = class App_Models_FormNotification extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\FormNotification", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\FormNotification", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\FormNotification", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\FormNotification", callback);
    }

    static backend_class_name() {
        return "App\\Models\\FormNotification";
    }

}

window.App_Models_FormSubmission = class App_Models_FormSubmission extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\FormSubmission", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\FormSubmission", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\FormSubmission", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\FormSubmission", callback);
    }

    static backend_class_name() {
        return "App\\Models\\FormSubmission";
    }

}

window.App_Models_Interaction = class App_Models_Interaction extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Interaction", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Interaction", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Interaction", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Interaction", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Interaction";
    }

}

window.App_Models_IpAddress = class App_Models_IpAddress extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\IpAddress", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\IpAddress", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\IpAddress", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\IpAddress", callback);
    }

    static backend_class_name() {
        return "App\\Models\\IpAddress";
    }

}

window.App_Models_LP_Model = class App_Models_LP_Model extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LP_Model", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LP_Model", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LP_Model", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LP_Model", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LP_Model";
    }

}

window.App_Models_LP_Model_Authenticatable = class App_Models_LP_Model_Authenticatable extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LP_Model_Authenticatable", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LP_Model_Authenticatable", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LP_Model_Authenticatable", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LP_Model_Authenticatable", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LP_Model_Authenticatable";
    }

}

window.App_Models_Lead = class App_Models_Lead extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Lead", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Lead", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Lead", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Lead", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Lead";
    }

    static STATUS_NEW = 1;
    static STATUS_REVIEWING = 6;
    static STATUS_CONTACTED = 2;
    static STATUS_QUALIFIED = 3;
    static STATUS_CONVERTED = 4;
    static STATUS_CLOSED = 5;
    static STATUS_UNQUALIFIED = 7;

    static status_enum_val() { return {
    "1": {
        "label": "New",
        "constant": "STATUS_NEW",
        "selectable": true,
        "display_order": 1
    },
    "6": {
        "label": "Reviewing",
        "constant": "STATUS_REVIEWING",
        "selectable": true,
        "display_order": 2
    },
    "2": {
        "label": "Contacted",
        "constant": "STATUS_CONTACTED",
        "selectable": true,
        "display_order": 3
    },
    "3": {
        "label": "Qualified",
        "constant": "STATUS_QUALIFIED",
        "selectable": true,
        "display_order": 4
    },
    "4": {
        "label": "Converted",
        "constant": "STATUS_CONVERTED",
        "selectable": true,
        "display_order": 5
    },
    "5": {
        "label": "Closed",
        "constant": "STATUS_CLOSED",
        "selectable": true,
        "display_order": 6
    },
    "7": {
        "label": "Unqualified",
        "constant": "STATUS_UNQUALIFIED",
        "selectable": true,
        "display_order": 7
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_Lead.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static SOURCE_FIRST_TO_KNOW = 'first_to_know';
    static SOURCE_CONTACT = 'contact';
    static SOURCE_SELLER = 'seller';
    static SOURCE_BUYER = 'buyer';
    static SOURCE_DIRT_ON_LAND = 'dirt_on_land';
    static SOURCE_LAND_EVAL = 'land_eval';
    static SOURCE_EVENT_ENTRY = 'event_entry';
    static SOURCE_MANUAL = 'manual';
    static SOURCE_IMPORT = 'import';
    static SOURCE_LEGACY = 'legacy';
    static SOURCE_AUCTION = 'auction';

    static source_enum_val() { return {
    "first_to_know": {
        "label": "1st to Know",
        "constant": "SOURCE_FIRST_TO_KNOW",
        "selectable": true
    },
    "contact": {
        "label": "Contact Form",
        "constant": "SOURCE_CONTACT",
        "selectable": false
    },
    "seller": {
        "label": "Seller",
        "constant": "SOURCE_SELLER",
        "selectable": false
    },
    "buyer": {
        "label": "Buyer",
        "constant": "SOURCE_BUYER",
        "selectable": false
    },
    "dirt_on_land": {
        "label": "Dirt On Land",
        "constant": "SOURCE_DIRT_ON_LAND",
        "selectable": false
    },
    "land_eval": {
        "label": "No Cost Land Evaluation",
        "constant": "SOURCE_LAND_EVAL",
        "selectable": false
    },
    "event_entry": {
        "label": "Event Entry",
        "constant": "SOURCE_EVENT_ENTRY",
        "selectable": false
    },
    "manual": {
        "label": "Manual Entry",
        "constant": "SOURCE_MANUAL",
        "selectable": true
    },
    "import": {
        "label": "CSV Import",
        "constant": "SOURCE_IMPORT",
        "selectable": false
    },
    "legacy": {
        "label": "Legacy Sync",
        "constant": "SOURCE_LEGACY",
        "selectable": false
    },
    "auction": {
        "label": "Auction Registrant",
        "constant": "SOURCE_AUCTION",
        "selectable": false
    }
}; }

    static source_enum_select() { 
                    return Object.entries(App_Models_Lead.source_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static PRIORITY_HOT = 1;
    static PRIORITY_WARM = 2;
    static PRIORITY_COLD = 3;

    static priority_enum_val() { return {
    "1": {
        "label": "Hot",
        "constant": "PRIORITY_HOT",
        "selectable": true
    },
    "2": {
        "label": "Warm",
        "constant": "PRIORITY_WARM",
        "selectable": true
    },
    "3": {
        "label": "Cold",
        "constant": "PRIORITY_COLD",
        "selectable": true
    }
}; }

    static priority_enum_select() { 
                    return Object.entries(App_Models_Lead.priority_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static LEAD_TYPE_BUYER = 'buyer';
    static LEAD_TYPE_SELLER = 'seller';
    static LEAD_TYPE_LAND_OWNER = 'land_owner';
    static LEAD_TYPE_INFLUENCER = 'influencer';
    static LEAD_TYPE_PROFESSIONAL_ADVISOR = 'professional_advisor';
    static LEAD_TYPE_OTHER = 'other';

    static lead_type_enum_val() { return {
    "buyer": {
        "label": "Buyer",
        "constant": "LEAD_TYPE_BUYER",
        "selectable": true
    },
    "seller": {
        "label": "Seller",
        "constant": "LEAD_TYPE_SELLER",
        "selectable": true
    },
    "land_owner": {
        "label": "Land Owner",
        "constant": "LEAD_TYPE_LAND_OWNER",
        "selectable": true
    },
    "influencer": {
        "label": "Influencer",
        "constant": "LEAD_TYPE_INFLUENCER",
        "selectable": true
    },
    "professional_advisor": {
        "label": "Professional Advisor",
        "constant": "LEAD_TYPE_PROFESSIONAL_ADVISOR",
        "selectable": true
    },
    "other": {
        "label": "Other",
        "constant": "LEAD_TYPE_OTHER",
        "selectable": true
    }
}; }

    static lead_type_enum_select() { 
                    return Object.entries(App_Models_Lead.lead_type_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_LeadAsset = class App_Models_LeadAsset extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadAsset", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadAsset", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadAsset", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadAsset", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadAsset";
    }

}

window.App_Models_LeadComment = class App_Models_LeadComment extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadComment", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadComment", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadComment", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadComment", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadComment";
    }

    static TYPE_NOTE = 'note';
    static TYPE_PHONE = 'phone';
    static TYPE_EMAIL = 'email';
    static TYPE_MEETING = 'meeting';
    static TYPE_SITE_VISIT = 'site_visit';

    static activity_type_enum_val() { return {
    "note": {
        "label": "Note",
        "constant": "TYPE_NOTE",
        "selectable": true,
        "icon": "fa-sticky-note"
    },
    "phone": {
        "label": "Phone Call",
        "constant": "TYPE_PHONE",
        "selectable": true,
        "icon": "fa-phone"
    },
    "email": {
        "label": "Email",
        "constant": "TYPE_EMAIL",
        "selectable": true,
        "icon": "fa-envelope"
    },
    "meeting": {
        "label": "Meeting",
        "constant": "TYPE_MEETING",
        "selectable": true,
        "icon": "fa-users"
    },
    "site_visit": {
        "label": "Site Visit",
        "constant": "TYPE_SITE_VISIT",
        "selectable": true,
        "icon": "fa-map-marker-alt"
    }
}; }

    static activity_type_enum_select() { 
                    return Object.entries(App_Models_LeadComment.activity_type_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_LeadContributor = class App_Models_LeadContributor extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadContributor", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadContributor", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadContributor", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadContributor", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadContributor";
    }

}

window.App_Models_LeadImport = class App_Models_LeadImport extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadImport", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadImport", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadImport", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadImport", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadImport";
    }

    static STATUS_PENDING = 1;
    static STATUS_IN_PROGRESS = 2;
    static STATUS_COMPLETED = 3;
    static STATUS_FAILED = 4;
    static STATUS_REVERTED = 5;

    static status_enum_val() { return {
    "1": {
        "label": "Pending",
        "constant": "STATUS_PENDING"
    },
    "2": {
        "label": "In Progress",
        "constant": "STATUS_IN_PROGRESS"
    },
    "3": {
        "label": "Completed",
        "constant": "STATUS_COMPLETED"
    },
    "4": {
        "label": "Failed",
        "constant": "STATUS_FAILED"
    },
    "5": {
        "label": "Reverted",
        "constant": "STATUS_REVERTED"
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_LeadImport.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_LeadImportRow = class App_Models_LeadImportRow extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadImportRow", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadImportRow", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadImportRow", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadImportRow", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadImportRow";
    }

    static OUTCOME_CREATED = 1;
    static OUTCOME_MATCHED = 2;
    static OUTCOME_SKIPPED_DUPLICATE = 3;
    static OUTCOME_SKIPPED_SPAM = 4;

    static outcome_enum_val() { return {
    "1": {
        "label": "Created",
        "constant": "OUTCOME_CREATED"
    },
    "2": {
        "label": "Matched",
        "constant": "OUTCOME_MATCHED"
    },
    "3": {
        "label": "Skipped Duplicate",
        "constant": "OUTCOME_SKIPPED_DUPLICATE"
    },
    "4": {
        "label": "Skipped Spam",
        "constant": "OUTCOME_SKIPPED_SPAM"
    }
}; }

    static outcome_enum_select() { 
                    return Object.entries(App_Models_LeadImportRow.outcome_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_LeadNotificationRecipient = class App_Models_LeadNotificationRecipient extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadNotificationRecipient", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadNotificationRecipient", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadNotificationRecipient", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadNotificationRecipient", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadNotificationRecipient";
    }

}

window.App_Models_LeadPotentialProperty = class App_Models_LeadPotentialProperty extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadPotentialProperty", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadPotentialProperty", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadPotentialProperty", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadPotentialProperty", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadPotentialProperty";
    }

}

window.App_Models_LeadSavedFilter = class App_Models_LeadSavedFilter extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\LeadSavedFilter", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\LeadSavedFilter", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\LeadSavedFilter", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\LeadSavedFilter", callback);
    }

    static backend_class_name() {
        return "App\\Models\\LeadSavedFilter";
    }

}

window.App_Models_Listing = class App_Models_Listing extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Listing", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Listing", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Listing", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Listing", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Listing";
    }

}

window.App_Models_Notification = class App_Models_Notification extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Notification", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Notification", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Notification", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Notification", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Notification";
    }

    static GENERIC_FLASH = 0;
    static REGISTRATION_APPROVED = 1;
    static REGISTRATION_DENIED = 2;
    static BID_APPROVED = 3;
    static BID_DENIED = 4;
    static YOU_WON_ITEM = 5;
    static YOU_LOST_ITEM = 6;
    static REGISTRATION_REMOVED = 7;
    static ASSIGNED_PADDLE_NUMBER = 8;
    static GENERIC_ALERT = 9;
    static OUTBID = 10;
    static MAX_BID_EXPIRED = 11;
    static OUTBID_TIE = 12;
    static MAX_BID_TIE = 13;
    static FINALIZING_PICK_YOUR_ITEMS = 14;
    static CHOICE_ROUND_COMPLETED_YOU_ARE_WINNER = 15;
    static CHOICE_ROUND_COMPLETED_NON_WINNER = 16;
    static AUCTION_HAS_ENDED = 17;
    static ITEM_SOLD_YOU_ARE_WINNER = 18;
    static OUTBID_ENTERPRISE_WF = 19;
    static OUTBID_ENTERPRISE_INDIVIDUAL = 20;
    static STANDARD_COMPLETED_YOU_ARE_WINNER = 21;
    static STANDARD_COMPLETED_NON_WINNER = 22;
    static AUCTION_COMPLETED_LOSER_POPUP = 23;
    static AUCTION_COMPLETED_WINNER_POPUP = 24;

    static code_enum_val() { return {
    "0": {
        "constant": "GENERIC_FLASH"
    },
    "1": {
        "constant": "REGISTRATION_APPROVED"
    },
    "2": {
        "constant": "REGISTRATION_DENIED"
    },
    "3": {
        "constant": "BID_APPROVED"
    },
    "4": {
        "constant": "BID_DENIED"
    },
    "5": {
        "constant": "YOU_WON_ITEM"
    },
    "6": {
        "constant": "YOU_LOST_ITEM"
    },
    "7": {
        "constant": "REGISTRATION_REMOVED"
    },
    "8": {
        "constant": "ASSIGNED_PADDLE_NUMBER"
    },
    "9": {
        "constant": "GENERIC_ALERT"
    },
    "10": {
        "constant": "OUTBID"
    },
    "11": {
        "constant": "MAX_BID_EXPIRED"
    },
    "12": {
        "constant": "OUTBID_TIE"
    },
    "13": {
        "constant": "MAX_BID_TIE"
    },
    "14": {
        "constant": "FINALIZING_PICK_YOUR_ITEMS"
    },
    "15": {
        "constant": "CHOICE_ROUND_COMPLETED_YOU_ARE_WINNER"
    },
    "16": {
        "constant": "CHOICE_ROUND_COMPLETED_NON_WINNER"
    },
    "17": {
        "constant": "AUCTION_HAS_ENDED"
    },
    "18": {
        "constant": "ITEM_SOLD_YOU_ARE_WINNER"
    },
    "19": {
        "constant": "OUTBID_ENTERPRISE_WF"
    },
    "20": {
        "constant": "OUTBID_ENTERPRISE_INDIVIDUAL"
    },
    "21": {
        "constant": "STANDARD_COMPLETED_YOU_ARE_WINNER"
    },
    "22": {
        "constant": "STANDARD_COMPLETED_NON_WINNER"
    },
    "23": {
        "constant": "AUCTION_COMPLETED_LOSER_POPUP"
    },
    "24": {
        "constant": "AUCTION_COMPLETED_WINNER_POPUP"
    }
}; }

    static code_enum_select() { 
                    return Object.entries(App_Models_Notification.code_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static TOPIC_GENERIC = 0;
    static TOPIC_BID_STATUS_CHANGE = 1;
    static TOPIC_ROUND_STATUS_CHANGE = 2;
    static TOPIC_REGISTRATION_UPDATE = 3;
    static TOPIC_BIDDING_COMPLETED_NOTICE = 4;
    static TOPIC_AUCTION_STATUS_CHANGE = 5;
    static TOPIC_BID_REJECTED = 6;
    static TOPIC_OUTBID_ENTERPRISE_INDIVIDUAL = 8;
    static TOPIC_AUCTION_COMPLETE = 9;

    static notification_topic_enum_val() { return {
    "0": {
        "constant": "TOPIC_GENERIC"
    },
    "1": {
        "constant": "TOPIC_BID_STATUS_CHANGE"
    },
    "2": {
        "constant": "TOPIC_ROUND_STATUS_CHANGE"
    },
    "3": {
        "constant": "TOPIC_REGISTRATION_UPDATE"
    },
    "4": {
        "constant": "TOPIC_BIDDING_COMPLETED_NOTICE"
    },
    "5": {
        "constant": "TOPIC_AUCTION_STATUS_CHANGE"
    },
    "6": {
        "constant": "TOPIC_BID_REJECTED"
    },
    "8": {
        "constant": "TOPIC_OUTBID_ENTERPRISE_INDIVIDUAL"
    },
    "9": {
        "constant": "TOPIC_AUCTION_COMPLETE"
    }
}; }

    static notification_topic_enum_select() { 
                    return Object.entries(App_Models_Notification.notification_topic_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_Photo = class App_Models_Photo extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Photo", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Photo", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Photo", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Photo", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Photo";
    }

}

window.App_Models_PocketSale = class App_Models_PocketSale extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\PocketSale", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\PocketSale", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\PocketSale", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\PocketSale", callback);
    }

    static backend_class_name() {
        return "App\\Models\\PocketSale";
    }

}

window.App_Models_Property = class App_Models_Property extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Property", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Property", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Property", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Property", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Property";
    }

    static STATUS_DRAFT = 3;
    static STATUS_PUBLISHED = 6;
    static STATUS_PENDING = 1;
    static STATUS_SOLD = 2;
    static STATUS_CANCELED = 5;

    static status_enum_val() { return {
    "3": {
        "order": 0,
        "web_order": 0,
        "label_frontend": "Draft",
        "label": "Draft",
        "constant": "STATUS_DRAFT",
        "badge": "bg-secondary",
        "visible_frontend": false
    },
    "6": {
        "order": 1,
        "web_order": 1,
        "label_frontend": "New Listing",
        "label": "New Listing",
        "constant": "STATUS_PUBLISHED",
        "badge": "bg-success",
        "visible_frontend": true
    },
    "1": {
        "order": 2,
        "web_order": 2,
        "label_frontend": "Under Contract",
        "label": "Under Contract",
        "constant": "STATUS_PENDING",
        "badge": "bg-secondary",
        "visible_frontend": true
    },
    "2": {
        "order": 3,
        "web_order": 3,
        "label_frontend": "Sold",
        "label": "Sold",
        "constant": "STATUS_SOLD",
        "badge": "bg-primary",
        "visible_frontend": true
    },
    "5": {
        "order": 5,
        "web_order": 5,
        "label_frontend": "Canceled",
        "label": "Canceled",
        "constant": "STATUS_CANCELED",
        "visible_frontend": false,
        "badge": "bg-warning",
        "visible": false
    }
}; }

    static status_enum_select() { 
                    return Object.entries(App_Models_Property.status_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_Region = class App_Models_Region extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Region", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Region", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Region", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Region", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Region";
    }

}

window.App_Models_Registrant = class App_Models_Registrant extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Registrant", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Registrant", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Registrant", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Registrant", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Registrant";
    }

    static CONTACT_PREFERENCE_NONE = 0;
    static CONTACT_PREFERENCE_SMS = 1;
    static CONTACT_PREFERENCE_EMAIL = 2;
    static CONTACT_PREFERENCE_PHONE = 3;

    static user_contact_preference_enum_val() { return {
    "0": {
        "label": "None",
        "constant": "CONTACT_PREFERENCE_NONE"
    },
    "1": {
        "label": "SMS",
        "constant": "CONTACT_PREFERENCE_SMS"
    },
    "2": {
        "label": "Email",
        "constant": "CONTACT_PREFERENCE_EMAIL"
    },
    "3": {
        "label": "Phone Call",
        "constant": "CONTACT_PREFERENCE_PHONE"
    }
}; }

    static user_contact_preference_enum_select() { 
                    return Object.entries(App_Models_Registrant.user_contact_preference_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_RegistrantSavedProperty = class App_Models_RegistrantSavedProperty extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\RegistrantSavedProperty", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\RegistrantSavedProperty", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\RegistrantSavedProperty", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\RegistrantSavedProperty", callback);
    }

    static backend_class_name() {
        return "App\\Models\\RegistrantSavedProperty";
    }

}

window.App_Models_RegistrantUpload = class App_Models_RegistrantUpload extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\RegistrantUpload", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\RegistrantUpload", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\RegistrantUpload", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\RegistrantUpload", callback);
    }

    static backend_class_name() {
        return "App\\Models\\RegistrantUpload";
    }

}

window.App_Models_Seo = class App_Models_Seo extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Seo", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Seo", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Seo", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Seo", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Seo";
    }

}

window.App_Models_ServerResizeHistory = class App_Models_ServerResizeHistory extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\ServerResizeHistory", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\ServerResizeHistory", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\ServerResizeHistory", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\ServerResizeHistory", callback);
    }

    static backend_class_name() {
        return "App\\Models\\ServerResizeHistory";
    }

}

window.App_Models_SmsQueue = class App_Models_SmsQueue extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\SmsQueue", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\SmsQueue", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\SmsQueue", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\SmsQueue", callback);
    }

    static backend_class_name() {
        return "App\\Models\\SmsQueue";
    }

}

window.App_Models_SocialLink = class App_Models_SocialLink extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\SocialLink", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\SocialLink", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\SocialLink", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\SocialLink", callback);
    }

    static backend_class_name() {
        return "App\\Models\\SocialLink";
    }

}

window.App_Models_Tag = class App_Models_Tag extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Tag", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Tag", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Tag", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Tag", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Tag";
    }

}

window.App_Models_TermsAndConditions = class App_Models_TermsAndConditions extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\TermsAndConditions", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\TermsAndConditions", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\TermsAndConditions", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\TermsAndConditions", callback);
    }

    static backend_class_name() {
        return "App\\Models\\TermsAndConditions";
    }

}

window.App_Models_Testimonial = class App_Models_Testimonial extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\Testimonial", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\Testimonial", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\Testimonial", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\Testimonial", callback);
    }

    static backend_class_name() {
        return "App\\Models\\Testimonial";
    }

}

window.App_Models_UnifiedSession = class App_Models_UnifiedSession extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\UnifiedSession", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\UnifiedSession", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\UnifiedSession", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\UnifiedSession", callback);
    }

    static backend_class_name() {
        return "App\\Models\\UnifiedSession";
    }

}

window.App_Models_User = class App_Models_User extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\User", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\User", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\User", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\User", callback);
    }

    static backend_class_name() {
        return "App\\Models\\User";
    }

    static ROLE_ROOT = 1;
    static ROLE_CLERK = 2;
    static ROLE_PRODUCTION = 3;
    static ROLE_AUCTION_MANAGER = 4;
    static ROLE_REAL_ESTATE_AGENT = 9;
    static ROLE_STAFF = 5;
    static ROLE_DIRECTOR = 6;
    static ROLE_TALENT = 7;
    static ROLE_AUCTIONEER = 8;
    static ROLE_SALES = 10;
    static ROLE_SALES_MANAGER = 11;
    static ROLE_INSIDE_SALES = 12;

    static role_enum_val() { return {
    "1": {
        "order": 0,
        "label": "Root",
        "constant": "ROLE_ROOT",
        "permissions": [
            1,
            12,
            13,
            2,
            3,
            4,
            5,
            7,
            8,
            9,
            10,
            11,
            19,
            16
        ],
        "can_admin_roles": [
            1,
            2,
            3,
            4,
            9,
            5,
            7,
            8,
            6,
            10,
            12,
            11
        ],
        "description": "Full system access for all functions. Can create users. Only root users can create other root users."
    },
    "2": {
        "order": 1,
        "label": "Clerk",
        "constant": "ROLE_CLERK",
        "permissions": [
            13,
            2,
            3,
            4,
            5,
            9,
            10,
            7,
            11,
            19,
            16
        ],
        "can_admin_roles": [
            2,
            3,
            4,
            9,
            5,
            7,
            8,
            6,
            10,
            12,
            11
        ],
        "description": "Full system access for all functions except 'audit log'.  Can create users.  Only the clerk and root users can create other clerk users."
    },
    "3": {
        "order": 2,
        "label": "Production",
        "constant": "ROLE_PRODUCTION",
        "permissions": [
            3,
            4,
            5,
            9,
            10,
            11,
            19,
            7,
            14,
            16
        ],
        "can_admin_roles": [
            3,
            4,
            9,
            5,
            7,
            8,
            6,
            10,
            12,
            11
        ],
        "description": "Can manage registrants, properties, and other marketing information.  Can create users."
    },
    "4": {
        "order": 3,
        "label": "Auction Manager",
        "constant": "ROLE_AUCTION_MANAGER",
        "permissions": [
            4,
            5,
            10,
            11,
            19,
            14,
            15,
            22
        ],
        "description": "Can manage registrants.  Can be assigned to properties and manage those properties."
    },
    "9": {
        "order": 4,
        "label": "Real Estate Agent",
        "constant": "ROLE_REAL_ESTATE_AGENT",
        "permissions": [
            4,
            5,
            10,
            19,
            14,
            15
        ],
        "description": "Can be assigned to properties and manage those properties. Cannot manage registrants."
    },
    "5": {
        "order": 5,
        "label": "General Staff",
        "constant": "ROLE_STAFF",
        "permissions": [
            4,
            5,
            14
        ],
        "description": "Read only system access."
    },
    "6": {
        "order": 6,
        "label": "Studio Director",
        "constant": "ROLE_DIRECTOR",
        "permissions": [
            5,
            4,
            7,
            14
        ],
        "description": "Read only access, bidder contact information hidden. Can start and stop the auctioncast stream."
    },
    "7": {
        "order": 7,
        "label": "Talent",
        "constant": "ROLE_TALENT",
        "permissions": [
            5
        ],
        "description": "Read only system access.  Bidder contact information hidden."
    },
    "8": {
        "order": 8,
        "label": "Auctioneer",
        "constant": "ROLE_AUCTIONEER",
        "permissions": [
            5
        ],
        "description": "Read only system access.  Bidder contact information hidden."
    },
    "10": {
        "order": 9,
        "label": "Sales",
        "constant": "ROLE_SALES",
        "permissions": [
            14,
            17,
            22
        ],
        "route_whitelist": [
            "\/",
            "\/home",
            "\/leads",
            "\/leads\/*",
            "\/campaigns",
            "\/campaigns\/*",
            "\/agents",
            "\/users",
            "\/users\/*",
            "\/settings",
            "\/settings\/profile",
            "\/calendar",
            "\/calendar\/*"
        ],
        "description": "Restricted to leads, campaigns, dashboard, and agent directory. Read access to all user profiles, can only edit own."
    },
    "11": {
        "order": 10,
        "label": "Sales Manager",
        "constant": "ROLE_SALES_MANAGER",
        "permissions": [
            5,
            14,
            17,
            18,
            20
        ],
        "can_admin_roles": [
            10,
            12,
            9
        ],
        "description": "Read-only across the system, except can edit Leads, Campaigns, and agent profiles. Can manage Sales users."
    },
    "12": {
        "order": 11,
        "label": "Inside Sales",
        "constant": "ROLE_INSIDE_SALES",
        "permissions": [
            14,
            17,
            20
        ],
        "route_whitelist": [
            "\/",
            "\/home",
            "\/leads",
            "\/leads\/*",
            "\/campaigns",
            "\/campaigns\/*",
            "\/agents",
            "\/users",
            "\/users\/*",
            "\/settings",
            "\/settings\/profile",
            "\/calendar",
            "\/calendar\/*"
        ],
        "description": "Same access as Sales, plus eligible to be assigned to a lead's Inside Sales Rep slot. Used by reps who collect property data and prep leads before agent handoff."
    }
}; }

    static role_enum_select() { 
                    return Object.entries(App_Models_User.role_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static VIP_LEADERSHIP = 0;
    static VIP_ELITE = 1;
    static VIP_DEFAULT = 2;

    static vip_type_enum_val() { return {
    "0": {
        "label": "Leadership",
        "constant": "VIP_LEADERSHIP"
    },
    "1": {
        "label": "Elite",
        "constant": "VIP_ELITE"
    },
    "2": {
        "label": "Default",
        "constant": "VIP_DEFAULT"
    }
}; }

    static vip_type_enum_select() { 
                    return Object.entries(App_Models_User.vip_type_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
    static AGENT_CLASSIFICATION_INSIDE_SALES = 'inside_sales';
    static AGENT_CLASSIFICATION_OUTSIDE_SALES = 'outside_sales';

    static agent_classification_enum_val() { return {
    "inside_sales": {
        "label": "Inside Sales",
        "constant": "AGENT_CLASSIFICATION_INSIDE_SALES",
        "selectable": true
    },
    "outside_sales": {
        "label": "Outside Sales",
        "constant": "AGENT_CLASSIFICATION_OUTSIDE_SALES",
        "selectable": true
    }
}; }

    static agent_classification_enum_select() { 
                    return Object.entries(App_Models_User.agent_classification_enum_val())
                        .sort(([,a], [,b]) => (a.order || 0) - (b.order || 0))
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
                }
}

window.App_Models_UserAward = class App_Models_UserAward extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\UserAward", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\UserAward", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\UserAward", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\UserAward", callback);
    }

    static backend_class_name() {
        return "App\\Models\\UserAward";
    }

}

window.App_Models_UserExpertise = class App_Models_UserExpertise extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\UserExpertise", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\UserExpertise", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\UserExpertise", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\UserExpertise", callback);
    }

    static backend_class_name() {
        return "App\\Models\\UserExpertise";
    }

}

window.App_Models_UserSubrole = class App_Models_UserSubrole extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\UserSubrole", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\UserSubrole", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\UserSubrole", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\UserSubrole", callback);
    }

    static backend_class_name() {
        return "App\\Models\\UserSubrole";
    }

}

window.App_Models_WebSession = class App_Models_WebSession extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\WebSession", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\WebSession", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\WebSession", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\WebSession", callback);
    }

    static backend_class_name() {
        return "App\\Models\\WebSession";
    }

}

window.App_Models_WebSessionActivity = class App_Models_WebSessionActivity extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\WebSessionActivity", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\WebSessionActivity", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\WebSessionActivity", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\WebSessionActivity", callback);
    }

    static backend_class_name() {
        return "App\\Models\\WebSessionActivity";
    }

}

window.App_Models_WebSessionPage = class App_Models_WebSessionPage extends _.Model_Record {
    constructor(data) {
        super("App\\Models\\WebSessionPage", data);
    }

    static get(id, revision = null) {
        return this.fetch(id, revision);
    }

    static fetch(id, revision = null) {
        return _.get_record("App\\Models\\WebSessionPage", id, revision);
    }

    static get_private(id, revision = null) {
        return this.fetch_private(id, revision);
    }

    static fetch_private(id, revision = null) {
        return _.get_record("App\\Models\\WebSessionPage", id, revision, 'private');
    }

    static subscribe(callback) {
        return _.model_subscribe("App\\Models\\WebSessionPage", callback);
    }

    static backend_class_name() {
        return "App\\Models\\WebSessionPage";
    }

}




_.get_model_class_by_name = function(the_name) {
    if(the_name == "App\\Models\\Activity" ) return App_Models_Activity;
    if(the_name == "App\\Models\\Agency" ) return App_Models_Agency;
    if(the_name == "App\\Models\\ApiClient" ) return App_Models_ApiClient;
    if(the_name == "App\\Models\\ApprovalComment" ) return App_Models_ApprovalComment;
    if(the_name == "App\\Models\\ApprovalDocument" ) return App_Models_ApprovalDocument;
    if(the_name == "App\\Models\\ApprovalRequest" ) return App_Models_ApprovalRequest;
    if(the_name == "App\\Models\\ApprovalRequirement" ) return App_Models_ApprovalRequirement;
    if(the_name == "App\\Models\\Auction" ) return App_Models_Auction;
    if(the_name == "App\\Models\\AuctionCast" ) return App_Models_AuctionCast;
    if(the_name == "App\\Models\\AuctionCastStreamHistory" ) return App_Models_AuctionCastStreamHistory;
    if(the_name == "App\\Models\\AuctionCastStreamViewerStats" ) return App_Models_AuctionCastStreamViewerStats;
    if(the_name == "App\\Models\\AuctionItem" ) return App_Models_AuctionItem;
    if(the_name == "App\\Models\\AuctionRegistration" ) return App_Models_AuctionRegistration;
    if(the_name == "App\\Models\\AuctionRound" ) return App_Models_AuctionRound;
    if(the_name == "App\\Models\\AuctionType" ) return App_Models_AuctionType;
    if(the_name == "App\\Models\\AuctioncastInvocation" ) return App_Models_AuctioncastInvocation;
    if(the_name == "App\\Models\\Bid" ) return App_Models_Bid;
    if(the_name == "App\\Models\\Campaign" ) return App_Models_Campaign;
    if(the_name == "App\\Models\\CampaignContributor" ) return App_Models_CampaignContributor;
    if(the_name == "App\\Models\\ChatConversation" ) return App_Models_ChatConversation;
    if(the_name == "App\\Models\\ChatConversationAdmin" ) return App_Models_ChatConversationAdmin;
    if(the_name == "App\\Models\\ChatMessage" ) return App_Models_ChatMessage;
    if(the_name == "App\\Models\\Coordinator" ) return App_Models_Coordinator;
    if(the_name == "App\\Models\\DayComment" ) return App_Models_DayComment;
    if(the_name == "App\\Models\\DbCache" ) return App_Models_DbCache;
    if(the_name == "App\\Models\\EmailQueue" ) return App_Models_EmailQueue;
    if(the_name == "App\\Models\\Event" ) return App_Models_Event;
    if(the_name == "App\\Models\\Form" ) return App_Models_Form;
    if(the_name == "App\\Models\\FormField" ) return App_Models_FormField;
    if(the_name == "App\\Models\\FormNotification" ) return App_Models_FormNotification;
    if(the_name == "App\\Models\\FormSubmission" ) return App_Models_FormSubmission;
    if(the_name == "App\\Models\\Interaction" ) return App_Models_Interaction;
    if(the_name == "App\\Models\\IpAddress" ) return App_Models_IpAddress;
    if(the_name == "App\\Models\\LP_Model" ) return App_Models_LP_Model;
    if(the_name == "App\\Models\\LP_Model_Authenticatable" ) return App_Models_LP_Model_Authenticatable;
    if(the_name == "App\\Models\\Lead" ) return App_Models_Lead;
    if(the_name == "App\\Models\\LeadAsset" ) return App_Models_LeadAsset;
    if(the_name == "App\\Models\\LeadComment" ) return App_Models_LeadComment;
    if(the_name == "App\\Models\\LeadContributor" ) return App_Models_LeadContributor;
    if(the_name == "App\\Models\\LeadImport" ) return App_Models_LeadImport;
    if(the_name == "App\\Models\\LeadImportRow" ) return App_Models_LeadImportRow;
    if(the_name == "App\\Models\\LeadNotificationRecipient" ) return App_Models_LeadNotificationRecipient;
    if(the_name == "App\\Models\\LeadPotentialProperty" ) return App_Models_LeadPotentialProperty;
    if(the_name == "App\\Models\\LeadSavedFilter" ) return App_Models_LeadSavedFilter;
    if(the_name == "App\\Models\\Listing" ) return App_Models_Listing;
    if(the_name == "App\\Models\\Notification" ) return App_Models_Notification;
    if(the_name == "App\\Models\\Photo" ) return App_Models_Photo;
    if(the_name == "App\\Models\\PocketSale" ) return App_Models_PocketSale;
    if(the_name == "App\\Models\\Property" ) return App_Models_Property;
    if(the_name == "App\\Models\\Region" ) return App_Models_Region;
    if(the_name == "App\\Models\\Registrant" ) return App_Models_Registrant;
    if(the_name == "App\\Models\\RegistrantSavedProperty" ) return App_Models_RegistrantSavedProperty;
    if(the_name == "App\\Models\\RegistrantUpload" ) return App_Models_RegistrantUpload;
    if(the_name == "App\\Models\\Seo" ) return App_Models_Seo;
    if(the_name == "App\\Models\\ServerResizeHistory" ) return App_Models_ServerResizeHistory;
    if(the_name == "App\\Models\\SmsQueue" ) return App_Models_SmsQueue;
    if(the_name == "App\\Models\\SocialLink" ) return App_Models_SocialLink;
    if(the_name == "App\\Models\\Tag" ) return App_Models_Tag;
    if(the_name == "App\\Models\\TermsAndConditions" ) return App_Models_TermsAndConditions;
    if(the_name == "App\\Models\\Testimonial" ) return App_Models_Testimonial;
    if(the_name == "App\\Models\\UnifiedSession" ) return App_Models_UnifiedSession;
    if(the_name == "App\\Models\\User" ) return App_Models_User;
    if(the_name == "App\\Models\\UserAward" ) return App_Models_UserAward;
    if(the_name == "App\\Models\\UserExpertise" ) return App_Models_UserExpertise;
    if(the_name == "App\\Models\\UserSubrole" ) return App_Models_UserSubrole;
    if(the_name == "App\\Models\\WebSession" ) return App_Models_WebSession;
    if(the_name == "App\\Models\\WebSessionActivity" ) return App_Models_WebSessionActivity;
    if(the_name == "App\\Models\\WebSessionPage" ) return App_Models_WebSessionPage;
    return null;
}
